import React from 'react'

interface EyeProps {
    /** SVG icon style class name */
    className?: string
    size?: string
}

/**
 * Eye svg
 * Usage : Viewed badge icon.
 * @param props - FR8IconProps
 * @returns ReactJsxElement -> FR8Svg Icon
 */

export const EyeSvg: React.FC<EyeProps> = (props) => {
    const { className, size = "14" } = props

    return (
        <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 5.25C6.75 5.25 2.25 9 1 12C2.25 15 6.75 18.75 12 18.75C17.25 18.75 21.75 15 23 12C21.75 9 17.25 5.25 12 5.25Z"
                stroke="#717171"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                stroke="#717171"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
